import { render } from "./CoachesList.vue?vue&type=template&id=74934423&scoped=true"
import script from "./CoachesList.vue?vue&type=script&lang=js"
export * from "./CoachesList.vue?vue&type=script&lang=js"

import "./CoachesList.vue?vue&type=style&index=0&id=74934423&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-74934423"

export default script